import React from "react";
import jQuery from "jquery";
import notification from "../../Assets/img/megaphone.svg";
import Topbar from "../Layout/Header/Topbar";

async function fetch_client_country() {
  let country_code = null;
  await fetch(
    "https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572"
  )
    .then((res) => res.json())
    .then(
      (result) => {
        country_code = result["country_code"];
      },
      (error) => {
        console.log(error);
      }
    );
  return country_code;
}

function google_recaptcha_policy() {
  return (
    <div>
      <span className="small-font pt-1">
        This site is protected by reCAPTCHA and the Google{" "}
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </span>
    </div>
  );
}

function pad_num(num) {
  var str_num = "0" + num;
  return str_num.substr(str_num.length - 2);
}

async function loadEdition(id) {
  let responseJson = await make_request({
    path: "editions/" + id,
    method: "GET",
  });

  if (responseJson) {
    if (responseJson.status === "success") {
      //   await localStorage.setItem(
      //     "current_level_id",
      //     JSON.stringify(responseJson["level_id"])
      //   );
      //   await localStorage.setItem(
      //     "current_level_name",
      //     JSON.stringify(responseJson["level_name"])
      //   );
      //   await localStorage.setItem(
      //     "completed_levels",
      //     JSON.stringify(responseJson["completed_levels"])
      //   );

      after_auth(responseJson);
    }
  }
}

async function get_current_level(edition_id = null) {
  let responseJson = await make_request({
    path: (!!edition_id || edition_id === 0)? "current_level?edition_id="+edition_id : "current_level",
    method: "GET",
  });
  if (responseJson["status"] === "success") {
    after_auth(responseJson);
  }
}

async function after_auth(responseJson) {
  if (!!responseJson.redirect_url) {
    return (window.location = responseJson.redirect_url);
  } else {
    await localStorage.setItem(
      "starts_in",
      (parseInt(responseJson["starts_in"]) * 1000).toString()
    );
    await localStorage.setItem(
      "starting_month",
      responseJson["starting_month"]
    );
    return (window.location = "/pre-start");
  }
}

function inaugural_alert(time) {
  return !!time && <Topbar />;
}

function seconds_to_clock(seconds) {
  let clock = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  if (seconds > 0) {
    clock = {
      days: Math.floor(seconds / (1000 * 60 * 60 * 24)),
      hours: Math.floor((seconds / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((seconds / 1000 / 60) % 60),
      seconds: Math.floor((seconds / 1000) % 60),
    };
  }
  return clock;
}

function calculateTimeLeft(start_time) {
  return seconds_to_clock(
    +new Date(start_time.replace(" ", "T")) - +new Date()
  );
}

async function download_the_asset(url, file_name) {
  await jQuery.ajax({
    url: url,
    method: "GET",
    xhrFields: {
      responseType: "blob",
    },
    success: function (data) {
      var a = document.createElement("a");
      var url = window.URL.createObjectURL(data);
      a.href = url;
      a.download = file_name;
      document.body.append(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    },
  });
}

function authenticate() {
  if (process.env.REACT_APP_API_URL.split("/").reverse()[0] == "guest") {
    return true
  }
  let current_user_header = localStorage.getItem("current_user_header");
  if (
    current_user_header &&
    JSON.parse(current_user_header) &&
    JSON.parse(current_user_header)["access-token"]
  ) {
    return true;
  } else {
    localStorage.clear();
  }
  // return window.location = "/login";
}

async function make_request(args) {
  let current_user_header = JSON.parse(
    localStorage.getItem("current_user_header")
  );
  let headers = null;
  // console.log("=== current_user_header for /"+args.path+" : "+JSON.stringify(current_user_header));
  if (current_user_header) {
    headers = Object.assign(
      {},
      {
        "Content-Type": "application/json",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        redirect: "follow",
        referrerPolicy: "no-referrer",
      },
      current_user_header
    );
  }
  var responseJson = null;
  await jQuery
    .ajax({
      type: args.method,
      url: process.env.REACT_APP_API_URL + "/" + args.path,
      data: JSON.parse(localStorage.getItem("current_user_header"))
        ? JSON.stringify(args.body)
        : args.body, // non CORS request need to raw
      beforeSend: (xhr) => {
        if (headers) {
          Object.entries(headers).map(([key, value]) => {
            return xhr.setRequestHeader(key, value);
          });
        }
      },
    })
    .done(async (response, status, jqXHR) => {
      if (status === "success") {
        if (args.path.includes("auth") && args.method !== "PUT") {
          current_user_header = {
            "token-type": jqXHR.getResponseHeader("token-type"),
            uid: jqXHR.getResponseHeader("uid"),
            client: jqXHR.getResponseHeader("client"),
          };
          //await localStorage.setItem('current_user', JSON.stringify(response.data));
        }
        // console.log("=== ResponseHeader "+jqXHR.getAllResponseHeaders());
        if (jqXHR.getResponseHeader("expiry")) {
          current_user_header["expiry"] = jqXHR.getResponseHeader("expiry");
        }
        if (jqXHR.getResponseHeader("access-token")) {
          current_user_header["access-token"] = jqXHR.getResponseHeader(
            "access-token"
          );
        }
        await localStorage.setItem(
          "current_user_header",
          JSON.stringify(current_user_header)
        );
        // console.log("=== status "+status);
        // console.log("=== response "+JSON.stringify(response));
        // console.log("=== current_user_header "+JSON.stringify(current_user_header));
        if (response && !!response.user_name) {
          await localStorage.setItem("current_user", response.user_name);
        }
        responseJson = response;
      }
    })
    .fail((e) => {
      if (e && e.status === 401 && args.path.indexOf("sign_in") === -1) {
        alert("Request /" + args.path + " failed due to : " + e.statusText);
        localStorage.clear();
        return (window.location = "/login");
      } else if (e && e.status === 422) {
        responseJson = {
          status: "failed",
          message: e,
        };
      } else if (e && e.status === 401) {
        responseJson = {
          status: "failed",
          message: e.responseJSON.errors.toString(),
        };
      }
    })
    .catch((error) => {
      // console.error(error);
    });
  if (responseJson) {
    //console.log("=== responseJson : " + JSON.stringify(responseJson));
    return responseJson;
  }
}

export {
  get_current_level,
  fetch_client_country,
  google_recaptcha_policy,
  pad_num,
  seconds_to_clock,
  after_auth,
  inaugural_alert,
  calculateTimeLeft,
  make_request,
  authenticate,
  download_the_asset,
  loadEdition,
};
